import { api } from './client';

export type SkuRoiDateGrain = 'day' | 'week' | 'month' | 'year';
export type SkuRoiSection = 'landing_material' | 'sku_spend' | 'paid_landing' | 'landing_product' | 'all_landing';
export type SkuRoiOptionField = 'account_name' | 'ad_type' | 'material_type' | 'campaign_name' | 'ad_group_name' | 'ad_name';

export interface SkuRoiMonitorRow {
  dimensions: Record<string, string>;
  metrics: Record<string, number>;
}

export interface SkuRoiMonitorResponse {
  list: SkuRoiMonitorRow[];
  summary: SkuRoiMonitorRow | null;
  total: number;
  page: number;
  total_page: number;
  section: SkuRoiSection;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: SkuRoiDateGrain;
}

export interface SkuRoiMonitorParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: SkuRoiDateGrain;
  section: SkuRoiSection;
  dimensions?: string;
  page?: number;
  size?: number;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
  one_level_channel?: string;
  two_level_channel?: string;
  three_level_channel?: string;
  product_sku?: string;
  platform_sku?: string;
  landing_page_type?: string;
  landing_page_detail?: string;
  business_sku_up_at?: string;
  busku_orig_price_newest?: string;
  busku_sales_price_newest?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  exclude_fields?: string;
  account_name?: string;
  ad_type?: string;
  material_type?: string;
  campaign_name?: string;
  ad_group_name?: string;
  ad_name?: string;
}

export interface SkuRoiOptionParams {
  brand_id: string;
  site_id: string;
  field: SkuRoiOptionField;
  search?: string;
  limit?: number;
}

export const skuRoiApi = {
  getMonitor: (params: SkuRoiMonitorParams) =>
    api.get<{ code: number; data: SkuRoiMonitorResponse }>('/sku-roi/monitor', { params }),
  getOptions: (params: SkuRoiOptionParams) =>
    api.get<{ code: number; data: { list: string[] } }>('/sku-roi/options', { params }),
};
